import type { MiddlewareFactory } from "@pharaday/auth";

import type { FeatureFlagEnum } from "../domain/feature-flag.enum";

export type PostHogBootstrap = {
  distinctID: string;
  isIdentifiedID: boolean;
  featureFlags: Record<string, boolean | string>;
};

export abstract class FeatureFlagService {
  abstract withFeatureFlagMiddleware: MiddlewareFactory;
  abstract isFeatureFlagEnabled(flag: FeatureFlagEnum, id: string): Promise<boolean>;
}
